export const replaceAll = function (
  this: String,
  searchValue: string | RegExp,
  replaceValue: string | ((substring: string, ...args: any[]) => string),
) {
  return this.replace(new RegExp(searchValue, 'g'), String(replaceValue));
};

if (!String.prototype.replaceAll) String.prototype.replaceAll = replaceAll;
